
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MailboxInterface, MailboxUserCreateInterface } from '@/services/Mailbox/interfaces';
import { Website } from '@/services/Website/interfaces';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateMailboxUserForm from '@/services/Mailbox/forms/CreateMailboxUserForm';


@Component({
  mixins: [Themeable],
})
export default class CreateMailboxUserDialog extends Vue {
  @Prop() data: {
    mailbox: MailboxInterface,
    website: Website,
  };

  public visible: boolean = true;
  public loading: boolean = true;

  public form: WPXFormValue<CreateMailboxUserForm> = new WPXFormValue<CreateMailboxUserForm>(CreateMailboxUserForm);

  public created(): void {
    this.loading = false;
  }

  public createMailboxUser(): void {
    const unixUserId = this.data?.website?.details?.unixUserId;
    if (!unixUserId) {
      this.$errorDialog.show('Unix user was not found for this website.');
      return;
    }

    const userCreateDTO: MailboxUserCreateInterface = {
      systemUserId: unixUserId,
      mailboxId: this.data.mailbox.id,
      address: `${this.form.data.address}@${this.data.website.domain}`,
      password: this.form.data.password,
      realName: this.form.data.realName !== '' ? this.form.data.realName : undefined,
      aliases: this.form.data.aliases,
      forwards: this.form.data.forwards,
    };

    this.$emit('create-user', userCreateDTO);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
